// extracted by mini-css-extract-plugin
export default {"container":"Credit_container__iOjwv"};